export default "__VITE_ASSET__E_K_GXzE__"